import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Grid, withWidth, withStyles } from "@material-ui/core";
import CtaCard from "./CtaCard";
import calculateSpacing from "./calculateSpacing";
// import BenefitsSection from './BenefitSection';
// import BigMoneySection from './BigMoneySection';

const styles = theme => ({
  cardWrapper: {
    marginLeft: "auto",
    marginRight: "auto",
    display: 'flex',
    flexDirection: 'column',
    width: 345
  },
  gridContainer: {
    paddingLeft: theme.spacing(12),
    paddingRight: theme.spacing(12),
    [theme.breakpoints.down("md")]: {
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10)
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4)
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
  },
  wrapper: {
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      marginTop: 0
    },
    paddingBottom: '10vh'
  },
});

const ctaItems = [
  {
    name: 'Solutions',
    text: 'Unlock the power of your content with our cutting-edge automation and custom software solutions.',
    ctaText: 'Learn More',
    link: '/solutions',
  },
  {
    name: 'Services',
    text: 'Bespoke software-based services and solutions for rapid resolution within content supply chain workflows.',
    ctaText: 'Learn More',
    link: '/services',
  },
]

function MainSection({ width, classes }) {

  return (    
    <div className={classes.wrapper}>
      <div className={classNames("container-fluid", "lg-p-bottom")}>
        <Grid container spacing={calculateSpacing(width)} className={classes.gridContainer}>
          {ctaItems.map((item, index) => (
            <Grid key={`cta-${index}`} item sm={12} md={4} className={classes.cardWrapper} data-aos="zoom-in-up">
              <CtaCard {...item} />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}

MainSection.propTypes = {
  width: PropTypes.string.isRequired,

};

export default withStyles(styles, { withTheme: true })(withWidth()(MainSection));
